import { writable } from 'svelte/store';
function createInputFocusStore() {
    const { subscribe, set } = writable(false);
    return {
        subscribe: subscribe,
        set: (newFocusState) => set(newFocusState),
    };
}
export const inputFocusedStore = createInputFocusStore();
